<template>
  <b-button v-if="visible" size="sm" variant="primary" :to="vsmRoute" aria-label="Back to VSM">
    <i class="fa fa-arrow-left"></i> Back to VSM
  </b-button>
</template>

<script>
import { mapState } from 'vuex'
import { hasVsmAccess, vsmRouteName } from '../utils/vsm_access'

export default {
  name: 'VsmBackLinkButton',
  computed: {
    ...mapState({ user: state => state.profile.user }),
    tenantFeatures() {
      return (this.user && this.user.features && this.user.features[this.user.tenant]) || {}
    },
    visible() {
      return hasVsmAccess(this.tenantFeatures)
    },
    vsmRoute() {
      const tenantType = this.user && this.user.types && this.user.types[this.user.tenant]
      return { name: vsmRouteName(tenantType, this.tenantFeatures) }
    },
  },
}
</script>
